import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import type { Column } from 'react-data-grid';
import { CustomizedDataGrid } from '../../customized_data_grid';
import Loader from '../../Loader/loader';
import './prestoObsRules.scss';
import { getprestoObsRules } from '../../../service/service';
import { useSearchParams } from 'react-router-dom';
import { getDefaultRuleData } from './prestoObsRulesUtils';

const prestoObsRules = () => {
	interface Row {
		instance: string;
		project: string;
		name: string;
		sizeInMB: string;
		contentType: string;

	}
	function getColumns(): Array<Column<Row>> {
		return getDefaultRuleData(paramStatus).column;
	}

	const [searchParams] = useSearchParams();
	const ruleName = searchParams.get('ruleName');
	const [defaultColumnNames, setDefaultColumnNames] = useState<any[]>([]);
	const [pageTitle, setPageTitle] = useState<string | null>(ruleName);
	const [paramStatus, setParamStatus] = useState(ruleName);

	const [extractFailureList, setExtractFailureList] = useState<Row[]>([]);
	const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
	const [filterInfo, setFilterInfo] = useState([]);
	const [filterData, setFilterData] = useState<Row[]>([]);
	const [paginationData, setPaginationData] = useState({ totalElements: 0, totalPages: 0 });
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const updatePageTitleStatus = () => {
		const statusParam = searchParams.get('ruleName');
		console.log(statusParam);
		setParamStatus(statusParam);
		const updatedData = getDefaultRuleData(statusParam);
		setPageTitle(updatedData.title);
		setDefaultColumnNames(updatedData.columnNames);
	};


	const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
		setLoading(true);
		ExtractFailureListingFunc(value, pageSize, sortingInfo, filterInfo).catch((error) => {
			setError(error);
		});
	};

	const handlepageSizeChange = (event: any) => {
		setLoading(true);
		ExtractFailureListingFunc(page, event.target.value, sortingInfo, filterInfo).catch((error) => {
			setError(error);
		});
	};

	const handleSorting = (sortingInfo: any) => {
		setLoading(true);
		ExtractFailureListingFunc(page, pageSize, sortingInfo, filterInfo).catch((error) => {
			setError(error);
		});
	};

	const parseFilter = (filterInfo: any, name?: string) => {
		const parsedFilter: any = {};
		Object.keys(filterInfo).forEach((key: any) => {
			if (key !== name && filterInfo[key] && filterInfo[key].length) {
				parsedFilter[key] = filterInfo[key];
			}
		});
		return parsedFilter;
	};

	const handleFilter = (filterInfo: any) => {
		setFilterInfo(filterInfo);
		setLoading(true);
		ExtractFailureListingFunc(
			1,
			pageSize,
			sortingInfo,
			parseFilter(filterInfo)
		).catch((error) => {
			setError(error);
		});
	};

	async function ExtractFailureListingFunc(pageNumber: any, size: any, sortingInfo: any, filterInfo: any) {
		setLoading(true);

		try {
			const res = await getprestoObsRules(pageNumber.toString(), size.toString(), sortingInfo, filterInfo, ruleName);
			if (res.success) {

				setExtractFailureList(res.data.observations);
				setPaginationData(res.data.page);
				setFilterData(res.data.filterOptions)
				setPage(pageNumber);
				setPageSize(size);
				setSortingInfo(sortingInfo);
				setFilterInfo(filterInfo);
			} else {
				setError('Failed to fetch data');
			}
		} catch (error) {
			setError('Failed to fetch data');
		}
		setLoading(false);
	}

	useEffect(() => {
		updatePageTitleStatus();
		ExtractFailureListingFunc(page, pageSize, sortingInfo, filterInfo).catch((error) => {
			setError(error);
		});
	}, [searchParams]);

	return (
		<div className="page-table extractFailure_tabledata">
			<div className="extract_failure_title">{pageTitle}</div>
			{error ? (
				<div
					style={{
						color: '#e5e5e5',
						marginLeft: '25%',
						padding: '10px',
						fontWeight: 500,
						gridColumn: '1 / -1'
					}}
				>
					Error occurred while fetching data. Please try again.
				</div>
			) : (


				<Grid>
					{!loading ? (
						<CustomizedDataGrid
							tableColumns={getColumns()}
							tableData={extractFailureList}
							tableType={pageTitle}
							defaultColumnNames={defaultColumnNames}
							onSorting={handleSorting}
							currSorting={sortingInfo}
							filterDataOptions={filterData}
							onFilterCheck={handleFilter}
							currFilter={filterInfo}
							page={page}
							pageSize={pageSize}
							paginationData={paginationData}
							listLength={extractFailureList.length}
							handlepageSizeChange={handlepageSizeChange}
							handlePageChange={handlePageChange}
							isDateRangeFilter={false}
							isDisabled={false}
						/>
					) : (
						<Loader />
					)}
				</Grid>
			)}
		</div>
	);
};

export default prestoObsRules;
